import { render, staticRenderFns } from "./BotonCompraAbonado.vue?vue&type=template&id=2521a98f"
import script from "./BotonCompraAbonado.vue?vue&type=script&setup=true&lang=js"
export * from "./BotonCompraAbonado.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports